import React, { useState } from "react";
import {toast} from 'react-hot-toast'
import {
  Button,
  Container,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { saveToken } from "../../redux/user/UserAction";
import logo from "../../assets/safe.png";

const UserSignup = ({setNewUserId})=> {
  // eslint-disable-next-line
  const dispatch = useDispatch()
  // eslint-disable-next-line
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] =  useState("")
  const [loading, setLoading] = useState(false);


  // eslint-disable-next-line
  const [token, setToken] = useState(""); // State to store the token
  const navigate = useNavigate();

  const isButtonDisabled = !email || !password || !confirmPassword || password !== confirmPassword;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true)

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email, password: password }),
    };

    try {
      const response = await fetch(
        "https://salama-api.onrender.com/users",
        options
      ); /**Replace with backend endpoint*/
      if (response.ok) {
        const responseData = await response.json();
        console.log(responseData)
        toast.success(`${responseData.message}`); 
        dispatch(saveToken({token: null, uid: responseData.uid}))
        setLoading(false)
        // Redirect to the merchant page
        navigate("/verify-email");
      } else {
        const errorResponse = await response.json();
        setLoading(false)
        toast.error(errorResponse.message)
        console.log(
          errorResponse.message ||
            "Something went wrong. Please try again later."
        );
      }
    } catch (error) {
      console.error("Failed to fetch", error);
      setLoading(false)
      toast.error(error)
      setError("Server error occurred. Please try again later.");
    }
  };

  return (
    <Container  className="min-h-96 w-3/4 flex items-center ">
      <div className="flex flex-col-reverse justify-between sm:flex-row  w-full">
        <div className="p-4 items-center h-full ">
          <div className="h-full w-full ">
            <Typography
              variant="h3"
              align="center"
              className="mb-4 text-success"
              gutterBottom
            >
              Signup
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              className="mb-4 text-gray-500"
              gutterBottom
            >
              Enter your account details.
            </Typography>
            <form onSubmit={handleSubmit}>
              <FormControl fullWidth sx={{ marginBottom: 4 }}>
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>

              <FormControl fullWidth sx={{ marginBottom: 1 }}>
                <TextField
                  label="Password"
                  type="password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>

              <FormControl fullWidth sx={{ marginBottom: 1 }}>
                <TextField
                  label="Confirm Password"
                  type="password"
                  variant="outlined"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mt-4"
                fullWidth
                onClick={handleSubmit}
                disabled={isButtonDisabled || loading}
                >
                  {loading ? 'Loading...' : 'Signup'}
              </Button>
            </form>
          </div>
          <div className="mt-4 flex flex-row items-center">
            <Typography variant="body2" className="text-gray-500 mr-2">
              Already registered?
            </Typography>
            <Link className='text-blue-400 ml-1' to='/login'> login </Link>
          </div>
        </div>
        <div className="p-4 h-full w-full sm:mx-auto ">
          <Typography variant="h3" align="center" className="mb-4 text-success">
            Welcome,
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className="mb-2 text-gray-500"
          >
            Ease and Authenticate your transaction with Salama pay
          </Typography>
          <img src={logo} alt="logo" className="w-96 m-auto h-96 p-4" />
        </div>
      </div>
    </Container>
  );
}

export default UserSignup;